<template>
	<div id="menu-container">
		<div
			v-if="1 === 2"
			class="w-full flex justify-between"
		>
			<div
				v-if="!carousel"
				class="w-full flex justify-between items-center px-2"
			>
				<div
					class="col-auto"
					:class="edit ? 'pr-0' : ''"
				>
					<button
						class="btn mr-3 btn-sm"
						:class="edit ? 'btn-danger' : 'btn-light'"
						style="border-radius: 16px; width: 60px"
						@click="EditingMenu"
					>
						<i
							class="far"
							:class="edit ? 'fa-times fa-lg' : 'fa-pencil-alt'"
						></i>
					</button>
					<button
						v-if="edit"
						class="btn btn-sm btn-success"
						style="border-radius: 16px; width: 60px"
						@click="SaveCustom(custom_menu)"
					>
						<i class="fal fa-check fa-lg"></i>
					</button>
				</div>
				<div class="col-auto">
					<div class="btn-group-checkbox d-inline-block align-middle">
						<label for="small">
							<input
								id="small"
								v-model="tmp_size"
								type="radio"
								value="sm"
								@click="SetIconsSize('sm')"
							/>
							<div
								class="btn btn-light btn-sm"
								style="padding: 11px 15px"
							>
								<b
									class="align-text-bottom"
									style="font-size: 0.7rem"
									>A</b
								>
							</div>
						</label>
						<label for="medium">
							<input
								id="medium"
								v-model="tmp_size"
								type="radio"
								name="tipo"
								value="md"
								@click="SetIconsSize('md')"
							/>
							<div
								class="btn btn-light btn-sm"
								style="padding: 9px 13px"
							>
								<b
									class="align-text-bottom"
									style="font-size: 1.05rem"
									>A</b
								>
							</div>
						</label>
						<label for="large">
							<input
								id="large"
								v-model="tmp_size"
								type="radio"
								name="tipo"
								value="xl"
								@click="SetIconsSize('xl')"
							/>
							<div
								class="btn btn-light btn-sm"
								style="padding: 6px 13px"
							>
								<b
									class="align-text-bottom"
									style="font-size: 1.3rem"
									>A</b
								>
							</div>
						</label>
					</div>
				</div>
			</div>
		</div>

		<div
			v-if="!edit"
			id="menu-buttons-wrapper"
			class="w-full gap-4 2xl:gap-2"
		>
			<router-link
				v-for="menu in filtered_menu"
				:key="`${menu.id}-${menu.role}`"
				class="btn-menu"
				:to="GetRoute(menu)"
			>
				<i
					:class="`${GetIcon(menu)} font-32 ${
						icon_size != 'sm' ? 'font-sm-40' : ''
					} text-theme`"
				>
				</i>
				<h5 class="m-0 font-16">
					{{ menu.text }}
				</h5>
				<div
					v-if="menu.text == 'Organizações' && requesters_unconfirmed"
					class="unconfirmed"
				>
					{{ requesters_unconfirmed }}
				</div>
			</router-link>
		</div>

		<draggable
			v-if="edit"
			v-model="custom_menu"
		>
			<transition-group
				name="flip-list"
				tag="div"
				class="form-row pb-5 justify-content-start"
			>
				<div
					v-for="menu in filtered_menu"
					:key="menu.role"
					class="mb-2 mt-1 sortable"
					:class="{
						'col-12 col-md-6 col-lg-4 col-xl-3': icon_size == 'xl',
						'col-6 col-md-4 col-lg-3 col-xl-2': icon_size == 'md',
						'col-6 col-md-3 col-lg-2 col-xl-auto':
							icon_size == 'sm',
					}"
				>
					<router-link
						class="box w-100 icons-card"
						:class="{
							'opacity-50':
								menu.role && !menu.force
									? DoesntHavePermission(menu.role)
									: false,
							'primary-hover':
								menu.role && !menu.force
									? !DoesntHavePermission(menu.role)
									: true,
							'mw-135px rounded-md': icon_size == 'sm',
						}"
						:to="GetRoute(menu)"
					>
						<div
							class="card-body text-center position-absolute ps-0 d-flex align-items-center justify-content-center"
						>
							<div class="form-row h-100">
								<div class="col-12 align-self-center">
									<i
										:class="`${menu.icon} fal font-32 ${
											icon_size != 'sm'
												? 'font-sm-40'
												: ''
										}  mt-3 text-theme`"
									>
									</i>
								</div>
								<div class="col-12 align-self-start">
									<h5
										class="m-0 font-16"
										:style="
											icon_size == 'sm'
												? 'font-weight: 500;'
												: ''
										"
									>
										{{ menu.text }}
									</h5>
								</div>
							</div>
						</div>
					</router-link>
				</div>
			</transition-group>
		</draggable>
	</div>
</template>

<script>
	import draggable from 'vuedraggable'
	import { mapGetters, mapActions } from 'vuex'

	const FORBIDDEN_ROLES_FOR_LEGACY = [
		37, // Editar conteúdos
		38, // Fazer agendamento de Pronto Atendimento
	]

	const CONTENT_ROLES = [
		17, // Bibliotéca
		18, // Gerenciar objetos variáveis
		19, // Gerenciar objetos dinâmicos
		20, // Gerenciar especialidades
		37, // Editar conteúdos
	]

	export default {
		components: {
			draggable,
		},
		props: {
			carousel: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				tmp_size: 'md',
				custom_menu: [],
				edit: false,
			}
		},
		computed: {
			...mapGetters('system', ['icon_size', 'menu_order']),
			...mapGetters('auth', [
				'roles',
				'requester_selected_object',
				'requesters',
				'is_registered',
				'subscription_info',
			]),
			requesters_unconfirmed() {
				let unconfirmeds = this.requesters.filter(r => {
					return typeof r.confirmed !== 'undefined' && !r.confirmed
				}).length

				return unconfirmeds > 9 ? '9+' : unconfirmeds
			},
			filtered_menu() {
				return this.custom_menu.filter(
					m => !this.DoesntHavePermission(m.role) || m.force
				)
			},
		},
		watch: {
			icon_size: {
				handler(val) {
					this.tmp_size = val
				},
				immediate: true,
			},
		},
		methods: {
			...mapActions('system', ['SetIconsSize', 'SetMenuOrder']),
			GetRoute(menu) {
				return { name: menu.route }
			},
			DoesntHavePermission(role) {
				const requester = this.requester_selected_object

				if (requester) {
					let isForbidden = this.CheckVersionsRole(requester, role)
					let isContentForbidden = this.CheckContentSubscriptionSync(
						requester,
						role
					)

					if (isForbidden || isContentForbidden) return true

					if (this.is_registered) {
						const subscription_info = this.subscription_info

						if (
							subscription_info &&
							subscription_info &&
							subscription_info.days_left <= 0 &&
							subscription_info.hours_left &&
							subscription_info.hours_left <= 0
						) {
							// return true
						}
					}

					const pf =
						requester.account_provider_id ===
						requester.account_requester_id

					if ((requester && requester.confirmed) || pf) {
						return this.roles.indexOf(parseInt(role)) < 0
					}
				}

				return true
			},
			CheckVersionsRole(requester, role) {
				const isLastVersion =
					FORBIDDEN_ROLES_FOR_LEGACY.indexOf(parseInt(role)) > -1

				if (requester.is_legacy_version && isLastVersion) {
					return true
				}

				return false
			},
			CheckContentSubscriptionSync(requester, role) {
				if (!CONTENT_ROLES.includes(role)) return false

				if (requester?.requester?.content_subscription?.sync_enabled)
					return true

				return false
			},
			EditingMenu() {
				this.edit = !this.edit

				// Cancel
				if (!this.edit) {
					this.custom_menu = this.menu_order
				}
			},
			SaveCustom(val) {
				this.edit = false

				const menu_ordered = val.map((m, i) => {
					return {
						order: i + 1,
						id: m.id,
					}
				})

				this.SetMenuOrder({
					menu_mapped: menu_ordered,
					custom_menu: val,
				})
			},
			GetIcon(menu) {
				const splitted = menu.icon.trim().split(' ')

				if (splitted.length > 1) {
					return splitted.join(' ')
				}

				return `fal ${splitted[0]}`
			},
		},
		beforeMount() {
			this.custom_menu = this.menu_order
		},
	}
</script>

<style lang="scss" scoped>
	.mw-135px {
		min-width: 135px;
	}

	h5 {
		white-space: break-spaces;
	}

	.flip-list-move {
		transition: transform 0.3s;
	}

	.rounded-md {
		border-radius: 1.4rem !important;
	}

	.unconfirmed {
		width: 1.5rem;
		height: 1.5rem;
		border-radius: 50%;
		border: 1px solid rgb(219, 34, 34);
		background-color: rgb(219, 34, 34);
		color: #fff;
		line-height: 1;
		font-weight: bold;
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		top: 0;
		right: -1.5rem;
		transform: translate(-50%, -50%);
	}

	.card-body {
		padding: 0.7rem;
	}

	.card-body h5 {
		white-space: unset;
	}

	#menu-container {
		background-color: var(--elementsBackgroundColor);
		border: 1px solid var(--elementsBackgroundColor);
		border-radius: 0.5rem;
		margin: 0.5rem;
		width: calc(100vw - 1rem);
		height: calc(100vh - 82px);
		display: flex;
		justify-content: center;
		align-items: center;

		#menu-buttons-wrapper {
			display: grid;
			grid-template-columns: repeat(8, clamp(5rem, 10vw, 10rem));
			grid-template-rows: repeat(5, 1fr);
			justify-items: center;
			align-items: center;
			justify-content: center;

			.btn-menu {
				background-color: var(--gridBackgroundColor);
				border: 1px solid var(--elementsBorderColor);
				border-radius: 0.5rem;
				padding: 1rem;
				width: clamp(5rem, 10vw, 9rem);
				height: clamp(5rem, 15vh, 9rem);
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				gap: 0.5rem;
				position: relative;

				h5 {
					text-align: center;
					white-space: normal;
					font-weight: 500;
				}

				&:hover {
					background-color: var(--newPrimaryHoverBackgroundColor);
					border-color: var(--newPrimaryHoverBackgroundColor);

					i,
					h5 {
						color: #fff;
					}
				}
			}
		}
	}
</style>
